import {ChangeDetectionStrategy, ChangeDetectorRef, Component, Host, Input, OnDestroy, OnInit} from '@angular/core';
import {AppModalService} from 'app/services/appModal.service';
import {Message} from '../../../../../../chat-sdk/src/entities/messages/message';
import {UserModelService} from '../../../../models/user-model.service';
import {WorkerStore} from '../../../../../../chat-sdk/src/api/worker';
import {ChatWrapperComponent} from '../chat-wrapper/item';
import {Subscription} from 'rxjs';

// @todo chat move common to abstract class
@Component({
  selector: 'app-chat-message',
  templateUrl: 'item.html',
  styleUrls: ['item.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ChatMessageComponent implements OnInit, OnDestroy {
  @Input() message: Message = null;
  workerStore: WorkerStore = null;

  chatWrapper: ChatWrapperComponent;
  cdr: ChangeDetectorRef;
  modalService: AppModalService;
  userService: UserModelService;

  subs: Subscription[] = [];

  constructor(
    @Host() chatWrapper: ChatWrapperComponent,
    cdr: ChangeDetectorRef,
    modalService: AppModalService,
    userService: UserModelService
  ) {
    this.chatWrapper = chatWrapper;
    this.cdr = cdr;
    this.modalService = modalService;
    this.userService = userService;
  }

  // get showUserName() {
  //
  //   const workerStore = this.message?.user?.getWorker();
  //   if (workerStore?.loadingStatus === 'ready') {
  //     return workerStore.worker.name;
  //   } else if (workerStore?.loadingStatus === 'loading' || workerStore?.loadingStatus === 'waiting') {
  //     return 'Loading...';
  //   } else {
  //     return 'Not found';
  //   }
  // }

  ngOnInit() {
    this.workerStore = this.message?.user?.getWorker();

    this.subs.push(this.workerStore?.updateEvent.subscribe(() => {
      this.cdr.detectChanges();
    }));

    this.message.registerOnUpdate((type) => {
      console.log('message update component', this.message, type);

      setTimeout(() => {
        this.cdr.detectChanges();
      }, 50);
    });
  }

  openAction() {
    if (!this.message.ready) {
      return;
    }
    this.modalService.openChatActionModal(this.message, (data) => {
      if (data?.action) {
        if (data.action === 'edit') {
          this.chatWrapper.keyboardModalComponent.reset();
          this.chatWrapper.keyboardModalComponent.editedMessage = this.message;

          if (this.message.content.replyToMessage) {
            this.chatWrapper.keyboardModalComponent.replyToMessage = this.message.content.replyToMessage;
          }
        }

        if (data.action === 'reply') {
          // this.chatWrapper.keyboardModalComponent.reset();
          this.chatWrapper.keyboardModalComponent.replyToMessage = this.message;
        }

        if (data.action === 'pin') {
          this.chatWrapper.group.pinMessage(this.message, true);
        }

        if (data.action === 'delete') {
          this.modalService.openConfirmModal({text: 'Вы уверены, что хотите удалить сообщение?'}, (res) => {
            if (res) {
              this.message.delete();
            }
          });
        }

        if (data.action === 'reaction' && data.reaction) {
          this.message.addReaction(data.reaction);
        }
      }
    });
  }

  getIcon() {
    if (!this.message.ready) {
      return 'message-sending';
    }

    // @todo chat add exception handle and icon message-notsended

    if (this.message.ready && this.message.state.getReadStates().length) {
      return 'message-read';
    }

    if (this.message.ready) {
      return 'message-arrived';
    }
  }

  getNameColorClasses() {
    const classes = [];
    const groupUserData = this.chatWrapper.group.users.getWorkerById(this.message.user.workerId);

    if (groupUserData?.public?.userColor) {
      classes.push(`color-${groupUserData.public.userColor}`);
    } else {
      classes.push(`color-secondary`);
    }

    return classes;
  }

  getTitleColorClasses() {
    const classes = [];
    const groupUserData = this.chatWrapper.group.users.getWorkerById(this.message.user.workerId);

    if (groupUserData?.public?.titleColor) {
      classes.push(`color-${groupUserData.public.titleColor}`);
    } else {
      classes.push(`color-secondary`);
    }

    return classes;
  }

  getTitle() {
    const groupUserData = this.chatWrapper.group.users.getWorkerById(this.message.user.workerId);

    if (groupUserData) {
      return groupUserData.public?.title;
    } else {
      return 'Больше не работает';
    }
  }

  reactions() {
    const keys = Object.keys(this.message.state.getReactionGrouped());
    return keys.map(key => ({
      key,
      count: this.message.state.getReactionGrouped()[key].length || 1
    }));
  }

  get isPined() {
    return this.message.id === this.chatWrapper.group.content?.pinMessages[0]?.id;
  }

  ngOnDestroy(): void {
    if (this.subs.length) {
      this.subs.forEach(item => item.unsubscribe());
    }
  }
}
